import * as React from "react";
import { Page, Text, Document, StyleSheet, Font } from "@react-pdf/renderer";
import PDFExportRelativeWorkingInCourt from "./PDFExportRelativeWorkingInCourt";
import PDFExportDebtObligation from "./PDFExportDebtObligation";
import PDFExportAdditionalIncome from "./PDFExportAdditionalIncome";
import PDFExportNonPaidActivity from "./PDFExportNonPaidActivity";
import PDFExportGiftAndDonation from "./PDFExportGiftAndDonation";
import { IReport8ApplicantPresentationModel } from "../../../../presenter/report/model/Report8ApplicantPresentationModel";
import ReportHeader from "../ReportHeader";
import SagoeUi from "../../../assets/fonts/623c7118249e082fe87a78e08506cb4b.ttf";
import SagoeUiItalic from "../../../assets/fonts/a1f05a6515e69ab2886bdaaf1489d410.ttf";
import SagoeUiBold from "../../../assets/fonts/60570a3f64a1fece44ebf71b43617029.ttf";

const Report8Template = ({
  translate,
  data,
  title,
  subtitle
}: {
  translate?: any;
  data?: IReport8ApplicantPresentationModel[];
  title?: string;
  subtitle?: string;
}) => {
  return (
    <Document title={subtitle}>
      {data?.map((item) => (
        <Page size="A4" style={styles.body} orientation={"landscape"}>
          <ReportHeader
            title={subtitle}
            translate={translate}
            subtitle={title}
            subtitleText={translate("reports.params.reporting_period")}
            otherParams={
              <Text style={styles.subtitle}>{`${translate(
                "report8.document_template.applicant"
              )}: ${item.fullName}`}</Text>
            }
          />
          <PDFExportRelativeWorkingInCourt
            translate={translate}
            data={item.relativesWorkingInCourt}
          />
          <PDFExportAdditionalIncome
            translate={translate}
            data={item.additionalIncome}
          />
          <PDFExportNonPaidActivity
            translate={translate}
            data={item.nonPaidActivities}
          />
          <PDFExportGiftAndDonation
            translate={translate}
            data={item.giftsAndDonations}
          />

          <PDFExportDebtObligation
            translate={translate}
            data={item.debtObligations}
          />
          <Text
            style={styles.pageNumbers}
            render={({ pageNumber, totalPages }) =>
              `${pageNumber} / ${totalPages}`
            }
            fixed
          />
        </Page>
      ))}
    </Document>
  );
};

export default Report8Template;

Font.register({
  family: "Segoe UI",
  fonts: [
    {
      src: SagoeUiBold,
      fontWeight: "bold"
    },
    {
      src: SagoeUiItalic,
      fontStyle: "italic"
    },
    { src: SagoeUi }
  ]
});

const styles = StyleSheet.create({
  body: {
    padding: 20
  },
  titleCol: {
    display: "flex",
    flexDirection: "column",
    padding: "0pt 5pt 5pt",
    marginLeft: "5pt",
    marginBottom: "5pt"
  },
  title: {
    fontSize: "14pt",
    height: "20pt",
    padding: "0pt 5pt 0pt",
    fontWeight: "bold",
    fontFamily: "Segoe UI"
  },
  subtitle: {
    fontSize: "8pt",
    padding: "0pt 5pt 0pt",
    fontFamily: "Segoe UI"
  },
  header: {
    fontSize: "8pt",
    padding: "0pt 5pt 0pt",
    fontWeight: "bold",
    fontFamily: "Segoe UI"
  },
  table: {
    display: "flex",
    width: "auto",
    borderStyle: "solid",
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
    borderLeftWidth: 0
  },
  tableRow: {
    margin: "auto",
    flexDirection: "row"
  },
  tableCol: {
    width: "16.66%",
    borderStyle: "solid",
    borderWidth: 1,
    borderTopWidth: 0
  },
  tableCell: {
    margin: "auto",
    marginLeft: 5,
    fontSize: 10,
    fontFamily: "Segoe UI"
  },
  previewTable: {
    display: "flex",
    width: "auto",
    borderStyle: "solid",
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
    borderLeftWidth: 0,
    flexDirection: "column"
  },
  previewRow: {
    margin: "auto",
    flexDirection: "row",
    width: "100%",
    display: "flex"
  },
  pageNumbers: {
    fontSize: 10,
    fontFamily: "Segoe UI",
    position: "absolute",
    bottom: "30pt",
    right: "37pt"
  }
});
